import { useState, useEffect } from "react";
import dayjs from "dayjs";

import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

import {
  InputLabel,
  TextField,
  Select,
  MenuItem,
  FormControl,
  Button,
  Grid,
} from "@mui/material";
import { useSelector } from "react-redux";

const emptyActivityData = {
  activity_name: "",
  start_date: "",
  end_date: "",
  task_id: "",
  description: "",
  employee_id: "",
  percent_complete: 0,
};
export default function ProjectActivitiesAddActivityDialog({
  setTaskCodeBool,
  open,
  setOpen,
  onAdd,
  lowestTasks,
  employees,
}) {
  const user = useSelector((state) => state.user);
  const [data, setData] = useState(emptyActivityData);
  const [dateBoundry, setDateBoundry] = useState({
    start_date: "",
    end_date: "",
  });

  const [taskEmployees, setTaskEmployees] = useState([]);

  useEffect(() => {
    if (open) setData(emptyActivityData);
  }, [open]);

  const handleDataChange = (e) => {
    setData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  useEffect(() => {
    if (data.task_id) {
      let task = lowestTasks.find((t) => t.id === data.task_id);

      setDateBoundry({
        start_date: task.start_date,
        end_date: task.end_date,
      });
      setData((prev) => ({
        ...prev,
        start_date: task.start_date,
        end_date: task.end_date,
      }));
      if (user.role === "User") {
        let emps = employees.filter((e) => e.id === user.roleId);
        const uniqueData = removeDuplicates(emps, "id");

        setTaskEmployees(uniqueData);
      } else {
        let emps = employees.filter((e) => e.task_id === data.task_id);
        const uniqueData = removeDuplicates(emps, "id");
        setTaskEmployees(uniqueData);
      }
    }
  }, [data.task_id]);

  return (
    <Dialog
      open={open}
      onClose={() => {
        //setOpen("PROJECT_TASK_ADD_ACTIVITY");
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <form
        onSubmit={(e) => {
          e.preventDefault();
          // const errors = validate(data);
          // if (Object.keys(errors).length === 0) {
          onAdd(data);

          // }
        }}
      >
        <DialogTitle id="alert-dialog-title">Add Activity</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ pt: 2 }}>
            <Grid item xs={12} sm={6} md={6}>
              <TextField
                fullWidth
                label="Name"
                className="name-textfeild"
                name="activity_name"
                required
                value={data.activity_name}
                onChange={handleDataChange}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Task</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={data.task_id}
                  label="Task"
                  name="task_id"
                  onChange={handleDataChange}
                  //   disabled={taskCodeBool}
                  required
                >
                  <MenuItem value="">Choose</MenuItem>
                  {lowestTasks.map((t, i) => (
                    <MenuItem key={i} value={t.id}>
                      {t.task_code} - {t.task_name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label-e">
                  Assign To
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label-e"
                  id="demo-simple-select-e"
                  value={data.employee_id}
                  label="Assign To"
                  name="employee_id"
                  required
                  disabled={!taskEmployees.length}
                  onChange={handleDataChange}
                >
                  <MenuItem value="">Choose</MenuItem>
                  {taskEmployees.map((t, i) => (
                    <MenuItem key={i} value={t.id}>
                      {t.email}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  inputFormat="MM/dd/yyyy"
                  disabled={data.task_id ? false : true}
                  label="Start Date"
                  value={new Date(data.start_date).toJSON()}
                  minDate={new Date(dateBoundry.start_date)}
                  maxDate={new Date(dateBoundry.end_date)}
                  // minDate={new Date(dateBoundry.start_date).toJSON()}
                  // maxDate={new Date(dateBoundry.end_date).toJSON()}
                  required
                  onChange={(newValue) => {
                    handleDataChange({
                      target: { name: "start_date", value: newValue },
                    });
                  }}
                  renderInput={(params) => <TextField {...params} fullWidth />}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  inputFormat="MM/dd/yyyy"
                  disabled={data.task_id ? false : true}
                  label="End Date"
                  value={new Date(data.end_date).toJSON()}
                  minDate={new Date(data.start_date)}
                  maxDate={new Date(dateBoundry.end_date)}
                  // minDate={getLaterDate(
                  //   dateBoundry.start_date,
                  //   data.start_date
                  // )}
                  // maxDate={dateBoundry.end_date}
                  required
                  onChange={(newValue) => {
                    handleDataChange({
                      target: { name: "end_date", value: newValue },
                    });
                  }}
                  renderInput={(params) => <TextField {...params} fullWidth />}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <TextField
                label="% Complete"
                fullWidth
                name="percent_complete"
                required
                type="number"
                value={data.percent_complete}
                onChange={handleDataChange}
              />
            </Grid>

            <Grid item xs={12} md={12}>
              <TextField
                label="Description"
                fullWidth
                name="description"
                value={data.description}
                onChange={handleDataChange}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setDateBoundry({
                start_date: "",
                end_date: "",
              });
              setData(emptyActivityData);
              setOpen("ADD_ACTIVITY");
              setTaskCodeBool(false);
            }}
            className="cancel-button"
          >
            Cancel
          </Button>
          <Button
            disabled={/^Trial_User$/i.test(user.role) ? true : false}
            type="submit"
            // onClick={() => {
            //   onAdd(data);
            // }}
            className="blue-button"
          >
            Add
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}

function getLaterDate(d1, d2) {
  return dayjs(d1).isAfter(dayjs(d2))
    ? new Date(d1).toJSON()
    : new Date(d2).toJSON();
}

function getEarlierDate(d1, d2) {
  return dayjs(d1).isBefore(dayjs(d2))
    ? new Date(d1).toJSON()
    : new Date(d2).toJSON();
}
function removeDuplicates(arr, prop) {
  return arr.filter(
    (obj, index, self) => index === self.findIndex((o) => o[prop] === obj[prop])
  );
}
